import isEqual from 'lodash/isEqual';
import type { BoardRecording, BoardRecordingMove } from './BoardRecorder';
import { BoardModel } from './models/board/BoardModel';
import { TileModel } from './models/board/TileModel';
import { waitForMs } from '../../utils/async-utils';
import type { BoardState } from './types';

export interface BoardPlaybackErrorDetails {
  initState: BoardState;
  move: BoardRecordingMove;
  output: BoardState;
}

export class BoardPlaybackError extends Error {
  constructor(
    message: string,
    public readonly details: BoardPlaybackErrorDetails,
  ) {
    super(message);
  }
}

async function performMove(model: BoardModel, move: BoardRecordingMove): Promise<void> {
  const stack = model.getStack(move.x, move.y);
  if (!stack) {
    throw new Error(`Cannot find stack at for move ${move.x}x${move.y}`);
  }

  let resolved = false;

  const callback = (): void => {
    resolved = true;
    model.onStateUpdate.disconnect(callback);
  };
  model.onStateUpdate.connect(callback);

  model.makeMove(
    stack.id,
    move.colors.map((color) => new TileModel(color)),
  );

  while (!resolved) {
    model.update(100);
    await waitForMs(0);
  }
}

export async function testRecording(recording: BoardRecording): Promise<void> {
  const model = new BoardModel({
    state: recording.initState,
  });

  // eslint-disable-next-line no-restricted-syntax
  for (const move of recording.moves) {
    const stateBeforeMove = model.exportState();
    await performMove(model, move);

    if (!isEqual(model.exportState(), move.output)) {
      throw new BoardPlaybackError('not equal', {
        initState: stateBeforeMove,
        move,
        output: model.exportState(),
      });
    }
  }
}
